import React from 'react';
import './css/LoadWidget.scss';

class LoadWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = { protons: new Array( 10 ).fill( 0 ).map( () => { return { angle: Math.random() * 180, upright: Math.random() > 0.5 } } ), time: 0 };
    }
    componentDidMount() {

        this.animID = requestAnimationFrame( this.update );

    }

    componentWillUnmount() {

        cancelAnimationFrame( this.animID );

    }

    update = delta => {

        this.animID = requestAnimationFrame( this.update )
        this.setState( { time: (this.state.time + delta )%4000/200 } );

    }

    render() {
        return (
            <div className="component-loadwidget">
                <h1>Loading...</h1>
                <svg viewBox="0 0 600 100">
                    <defs>
                        <linearGradient id="grad">
                            <stop offset="0%" stopColor="rgb(100,100,255)" stopOpacity="0"/>
                            <stop offset="90%" stopColor="rgb(100,100,255)" stopOpacity="0.8"/>
                            <stop offset="100%" stopColor="rgb(100,100,255)" stopOpacity="0.4"/>
                        </linearGradient>
                    </defs>
                    <g transform="translate( 300, 50 )">
                        {this.state.protons.map( ( val, i ) => <Proton key={i} xOffset={ ( i*60 ) - 300 } upright={val.upright} aligned={this.state.time > i && this.state.time < i + 2} angle={val.angle}/> )}
                    </g>
                    <rect height="100%" width="50" x={this.state.time * 60 - 60} fill="url(#grad)" className={`proton-field ${this.state.time > 10 ? "faded" : ""}`}/>
                </svg>
            </div>
        )
    }
}

const Proton = props => (
    <g className="loading-proton" transform={`translate( ${props.xOffset} )`}>
        <g className={props.aligned ? "proton-pulse" : ""}>
            <g className={props.aligned ? ( props.upright ? "proton-up" : "proton-down" ) : ""} transform={`rotate( ${props.angle} )`}>
                <circle r="15"/>
                <line y1="-30" y2="25" />
                <line x1="0" x2="-10" y1="-30" y2="-20" />
                <line x1="0" x2="10" y1="-30" y2="-20" />
            </g>
        </g>
    </g>
)

export default LoadWidget;
